import ReportAPI from '@/api/Report'
import { CampaignModel, CampaignItemModel } from '@/models/Campaign'

const assignCampaignModel = data => {
  return data.map(o => new CampaignModel(o))
}

const assignItemModel = data => {
  return data.map(o => new CampaignItemModel(o))
}

const actions = {
  async GET_CAMPAIGN_LIST({ commit, dispatch, state }, { advertiserId }) {
    const listData = await dispatch('fetchCampaignData', advertiserId)
    const { columns, data } = listData
    const modeledItems = assignCampaignModel(data)
    const campaignList = { columns, list: modeledItems }
    commit('SET_CAMPAIGN_LIST', campaignList)
  },
  async fetchCampaignData(context, advertiserId) {
    const params = {}
    return ReportAPI.fetchCampaignList(advertiserId, params)
  },
  async GET_CAMPAIGN_REPORT(
    { commit, dispatch, state },
    { item, advertiserId },
  ) {
    const reportData = await dispatch('fetchReportData', { item, advertiserId })
    const { columns, data } = reportData
    const modeledItems = assignItemModel(data)
    return { columns, list: modeledItems }
  },
  async fetchReportData(context, { item, advertiserId }) {
    const insertionOrderId = item.insertionOrderId
    const params = { insertionOrderId }
    return ReportAPI.fetchCampaignReport(advertiserId, params)
  },
}

export default actions
